
import { Component, Prop, Vue } from 'vue-property-decorator';

import { Course, Group, NewGroupData, Project } from 'ag-client-typescript';

import APIErrors from '@/components/api_errors.vue';
import { APIErrorsExposed } from '@/exposed_component_types/api_errors_exposed';
import GroupMembersForm from '@/components/group_members_form.vue';
import ValidatedForm from '@/components/validated_form.vue';
import { handle_api_errors_async } from '@/error_handling';

export interface GroupMember {
  id: number;
  username: string;
}

@Component({
  components: {
    APIErrors,
    GroupMembersForm,
    ValidatedForm,
  }
})
export default class CreateSingleGroup extends Vue {
  @Prop({required: true, type: Course})
  course!: Course;

  @Prop({required: true, type: Project})
  project!: Project;

  d_creating_group = false;

  @handle_api_errors_async(handle_create_group_error)
  async create_group(usernames: string[]) {
    try {
      this.d_creating_group = true;
      const api_errors = this.$refs.api_errors as APIErrorsExposed | undefined;
      api_errors?.clear();

      await Group.create(this.project.pk, {member_names: usernames});
    }
    finally {
      this.d_creating_group = false;
    }
  }
}

function handle_create_group_error(component: CreateSingleGroup, error: unknown) {
  const api_errors = component.$refs.api_errors as APIErrorsExposed | undefined;
  api_errors?.show_errors_from_response(error);
}
